import { ReactElement, useState } from 'react'
import { Theme } from '@mui/material/styles'
import CollapsibleBox from '../CollapsibleBox'

interface BaseProps {
  children: React.ReactNode
  label: string
  startIcon?: React.ReactNode
  dataCy?: string
  defaultExpanded?: boolean
  headerBackgroundColor?: string | ((theme: Theme) => string)
  headerTextColor?: string | ((theme: Theme) => string)
}

interface SwitchVariantProps extends BaseProps {
  variant: 'switch'
}

interface ExpanderVariantProps extends BaseProps {
  variant: 'expander'
}

type Props = SwitchVariantProps | ExpanderVariantProps

const CollapsibleBoxInternalState = ({
  children,
  variant,
  label,
  startIcon,
  dataCy,
  defaultExpanded = false,
  headerBackgroundColor,
  headerTextColor,
}: Props): ReactElement => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  if (variant === 'switch') {
    return (
      <CollapsibleBox
        variant="switch"
        label={label}
        isExpanded={isExpanded}
        handleToggle={event => setIsExpanded(event.target.checked)}
        startIcon={startIcon}
        dataCy={dataCy}
        headerBackgroundColor={headerBackgroundColor}
        headerTextColor={headerTextColor}
      >
        {children}
      </CollapsibleBox>
    )
  }

  return (
    <CollapsibleBox
      variant="expander"
      label={label}
      isExpanded={isExpanded}
      handleToggle={() => setIsExpanded(prev => !prev)}
      startIcon={startIcon}
      dataCy={dataCy}
      headerBackgroundColor={headerBackgroundColor}
      headerTextColor={headerTextColor}
    >
      {children}
    </CollapsibleBox>
  )
}

export default CollapsibleBoxInternalState
